__webpack_require__.p = "/triple-fantasy-card-logger/";